import { Injectable, signal } from '@angular/core';
import { Identity } from '@xanadu/model';

@Injectable({
    providedIn: 'root'
})
export class AuthSignal {
    readonly identity = signal<Identity | undefined>(undefined);
}
